import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory, useParams } from 'react-router-dom';
import DataGrid from '../components/DataGrid';
import Swal from 'sweetalert2'
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { DESERVE_STATUS, DESERVE_BLOCKED_STATUS, DESERVE_STATUS_STRING_VALUE } from "../components/constants";
import { formatDate } from '../common/util';

const SingleProductView = () => {
  const history = useHistory();
  const { idProduct } = useParams();
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const [product, setProduct] = useState();
  const [productStatus, setProductStatus] = useState();
  const { getAccessTokenSilently } = useAuth0();

  const statusLookup = Object.entries(DESERVE_STATUS)
    .reduce((acc, [key, value]) => {
      acc[value] = DESERVE_STATUS_STRING_VALUE[key];
      return acc;
    }, {});

  const columns = [
    {
      title: '',
      field: '',
      sorting: false,
      filtering: false,
      render: rowData => (
        (rowData.status == DESERVE_STATUS.ACCEPTED_BY_ADMIN ||
          rowData.status == DESERVE_STATUS.ACCEPTED_BY_COMPANY ||
          rowData.status == DESERVE_STATUS.REJECTED_BY_COMPANY) &&

        <IconButton
          color="primary"
          onClick={() =>
            window.open(`/companyReview/${idProduct}/${rowData.deservingUserId}`, "_blank") // ✅ open in new window
          }
        >
          <EditIcon />
        </IconButton>
      )
    },
    { field: 'index', title: 'Nummer', filtering: false },
    {
      field: 'status', title: 'Status',
      //Always to be updated according to DESERVE_STATUS constant in Java Code
      //Can be Moved to Constant file in React
      lookup: statusLookup,
    },
    { field: 'deservingUser', title: 'User' },
    { field: 'postUrl', title: 'Post URL' }
  ];

  useEffect(() => {
    async function getProduct() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);

      const response = await fetch(`${serverUrl}/api/singleProductView/` + idProduct, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
      const product = await response.json();
      setUserDeserveForProduct(product);
      setProduct(product.product);
    }
    getProduct();

  }, []);

  const setUserDeserveForProduct = (product) => {
    var openQunatities = 0;
    //Get userDeserveLength which are only currently open or accepted
    //Get the list of blocked status values
    const blockedStatuses = Object.values(DESERVE_BLOCKED_STATUS);

    // Filter products that have any of those statuses
    const filtered = product.userDeserve.filter(x =>
      blockedStatuses.includes(x.status)
    );

    openQunatities = product.product.quantity - filtered.length;

    var userDeserve = product.userDeserve;
    for (var i = 0; i < openQunatities; i++) {
      const emptyObject = { status: "0", deservingUser: "-", postUrl: "-" };
      userDeserve.push(emptyObject);
    }

    userDeserve.forEach((userDeserve, index) => {
      userDeserve.index = index + 1;
    });
    setProductStatus(userDeserve);
  }


  const backToAllProducts = () => {
    try {
      history.push("/allMyProducts");
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  }

  const goToEditProduct = (idProduct) => {
    try {
      history.push(`/addEditProduct/${idProduct}`);
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  }

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-outline-warning",
      cancelButton: "btn btn-outline-warning"
    },
    buttonsStyling: false
  });

  const getApprovedStatus = (product) => {
    if (product && product.approvedStatus != undefined) {
      if (product.approvedStatus == 0) return "Ausstehend";
      else if (product.approvedStatus == 1) return "Genehmigt";
      else if (product.approvedStatus == -1) return "Abgelehnt";
    }
  }

  return (
    <React.Fragment>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Produktansicht</h1>
            </div>
          </div>
        </div>
        <div className='row mb-20'>
          <div>
            <button id={"edit"} className="btn btn-outline-warning float-right col-md-6"
              block="true" onClick={() => goToEditProduct(product.idProduct)}>
              Bearbeiten
            </button>
            <button type="button" id={"backToAllProducts"} className="btn btn-outline-warning float-right col-md-6"
              onClick={() => backToAllProducts()}>
              <i className="fa fa-solid fa-arrow-left"></i>
              Zurück
            </button>
          </div>
        </div>
      </section><section className="content">

        <div className="card card-solid">

          {/* <Spinner isRunning={isRunning} /> */}
          <div className="card-body">

            <div className='row'>
              <div className="col-12 col-sm-5">

                <div className="col-12 text-center">
                  <img className="product-image-resized" src={product && product.imageUrl} alt="Loading..."></img>
                </div>

              </div>
              <div className="col-12 col-sm-1"></div>
              <div className="col-12 col-sm-6">

                <h3 className="profile-username text-center">{product && product.name}</h3>

                <p className="text-muted text-center">{product && product.nameIntern}</p>
                <br />
                <p className="text-muted text-center">{product && product.details}</p>

                <ul className="list-group list-group-unbordered mb-3">
                  <li className="list-group-item">
                    <b>Homepage</b>
                    <span className="float-right">
                      <a href={product?.homePage} target="_blank">{product?.companyName}</a>
                    </span>
                  </li>
                  {/* <li className="list-group-item">
                    <b>Interner Produktname</b>
                    <span className="float-right">{product && product.nameIntern}</span>
                  </li> */}
                  <li className="list-group-item">
                    <b>Benötigte Likes</b>
                    <span className="float-right">{product && product.price}</span>
                  </li>
                  <li className="list-group-item">
                    <b>Zeit</b>
                    <span className="float-right">{product?.timeperiode} {product?.timeperiodeCurrency}</span>
                  </li>
                  <li className="list-group-item">
                    <b>Beginn ab</b>
                    <span className="float-right">{formatDate(product?.timeperiodeFrom)}</span>
                  </li>
                  <li className="list-group-item">
                    <b>Ende am</b>
                    <span className="float-right">{formatDate(product?.timeperiodeTo)}</span>
                  </li>
                  <li className="list-group-item">
                    <b>Status</b>
                    <span className="float-right">{getApprovedStatus(product)}</span>
                  </li>
                  {product && product.approverComment && product.approvedStatus == -1 &&
                    <li className="list-group-item">
                      <b>Kommentar vom Admin</b>
                      <span className="float-right">{product.approverComment}</span>
                    </li>
                  }
                </ul>
              </div>


              <hr />
            </div>

            <div className="col-12 col-sm-12">
              <br />
              <DataGrid
                title='deserve Status' //"Product Deserve Status"
                columns={columns}
                data={productStatus}
                options={{
                  filtering: true,
                  sorting: true,
                  exportButton: true,
                  pageSize: 10, // Show 10 rows by default
                  pageSizeOptions: [5, 10, 20],
                  //grouping: true,
                  // rowStyle: (rowData, index ) => ({
                  //   backgroundColor:
                  //   index % 2 === 0 ? "#ebffeb" : "#ffebff",
                  //   }),
                }} />
            </div>

          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default SingleProductView;

